<script lang="ts" setup>
  import { parseAssetPath } from '~/utils/parseAssetPath'

  const { path } = useRoute()
  const isLoading = ref(false)

  const content = computed<any>(() => {
    return useAttrs().content
  })

  const defaultMetaImage = parseAssetPath('https://a.storyblok.com/f/236210/1504x1000/183111c8b2/investors-share.jpg')

  const pageLayout = computed(() => content.value?.layout ?? 'default')

  setPageLayout(pageLayout.value)

  definePageMeta({
    layout: false
  })

  const meta = content.value?.meta
  const excludeFromIndexing = content.value?.excludeFromIndexing
  if (meta) {
    useSeoMeta({
      robots: () => (excludeFromIndexing ? 'noindex, nofollow' : 'index, follow'),
      title: () => meta?.title,
      description: () => meta?.description,
      ogUrl: () => path,
      ogTitle: () => meta?.og_title || meta?.title,
      ogDescription: () => meta?.og_description || meta?.description,
      ogType: 'website',
      ogImage: () => meta?.og_image || defaultMetaImage,
      ogSiteName: 'Investor Page',
      twitterTitle: meta?.twitter_title || meta?.title,
      twitterDescription: meta?.twitter_description || meta?.description,
      twitterImage: meta?.twitter_image || defaultMetaImage,
      twitterCard: 'summary'
    })
  }
</script>
<template>
  <StoryblokComponent
    v-if="!isLoading && content"
    :blok="content"
  />
</template>
